"use client";

import MainPage from "@/components/mainPage";

export default function HomePage() {
  return (
    <MainPage />
  )
}
